import { generateUUID } from '@bizzdesign/bizzdesign-sdk/uuid';

export const generateViewId = (): string => generateUUID();
